(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const videos = [...document.querySelectorAll('video[data-baby-motion]')];
  if (!videos.length) return;
  videos.forEach(video => { video.controls = false; video.removeAttribute('controls'); video.muted = true; video.defaultMuted = true; video.loop = true; video.playsInline = true; video.disablePictureInPicture = true; if (reduced.matches) video.autoplay = false; });
  const visibility = new WeakMap();
  const groups = [...document.querySelectorAll('[data-baby-motion-group]')];
  const allowed = video => !reduced.matches && !document.hidden && visibility.get(video) && (!video.closest('details') || video.closest('details').open) && video.closest('[data-baby-motion-group]')?.dataset.motionPaused !== 'true';
  const play = video => {
    if (!visibility.get(video)) return video.pause();
    if (!video.dataset.loaded) {
      video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
      video.dataset.loaded = 'true';
      video.load();
    }
    if (!allowed(video)) return video.pause();
    video.muted = true;
    video.play().catch(() => {
      // Keep the poster if autoplay is blocked; never show a native toolbar.
      video.controls = false;
    });
  };
  const refresh = () => videos.forEach(play);
  const label = group => {
    const button = group.querySelector('[data-baby-motion-toggle]');
    if (!button) return;
    const paused = group.dataset.motionPaused === 'true';
    button.textContent = paused ? 'Lire les animations' : 'Mettre en pause';
    button.setAttribute('aria-pressed', String(!paused));
  };
  groups.forEach(group => {
    group.dataset.motionPaused = String(reduced.matches);
    label(group);
    group.querySelector('[data-baby-motion-toggle]')?.addEventListener('click', () => {
      group.dataset.motionPaused = String(group.dataset.motionPaused !== 'true');
      label(group);
      refresh();
    });
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        visibility.set(entry.target, entry.isIntersecting);
        play(entry.target);
      });
    }, {rootMargin: '120px 0px', threshold: .12});
    videos.forEach(video => observer.observe(video));
  } else {
    videos.forEach(video => visibility.set(video, true));
    refresh();
  }
  document.addEventListener('visibilitychange', refresh);
  document.querySelectorAll('.baby-hero-demo').forEach(details => details.addEventListener('toggle', refresh));
  document.addEventListener('pointerdown', refresh, {passive: true});
  reduced.addEventListener('change', event => {
    groups.forEach(group => { group.dataset.motionPaused = String(event.matches); label(group); });
    refresh();
  });
  videos.forEach(video => video.addEventListener('error', () => {
    video.controls = false;
    video.setAttribute('aria-label', 'La vidéo ne se charge pas. Son image de présentation reste disponible.');
  }));
})();
